<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :key="formType + '_' + (form.id || 'new')">
      <!--      <a-form-model-item label="用户ID｛zb_user.id｝" prop="userId" >-->
      <!--        <a-input v-model="form.userId" placeholder="请输入用户ID｛zb_user.id｝" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="医院认证ID｛zb_hospital_auth.id｝" prop="hospitalAuthId" >-->
      <!--        <a-input v-model="form.hospitalAuthId" placeholder="请输入医院认证ID｛zb_hospital_auth.id｝" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="医院名称" prop="hospitalName" >
        <a-input v-model="form.hospitalName" placeholder="请输入内容" allow-clear />
      </a-form-model-item>
      <!--      <a-form-model-item label="省ID" prop="provinceId" >-->
      <!--        <a-input v-model="form.provinceId" placeholder="请输入省ID" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="省市区" prop="provinceName" >
        <a-cascader
          v-model="addressSelect"
          :options="addressList"
          @change="handleChange"
          :field-names="{ label: 'areaName', value: 'areaId', children: 'children' }"
          allow-clear
          placeholder="请选择" />
      </a-form-model-item>
      <!--      <a-form-model-item label="市ID" prop="cityId" >-->
      <!--        <a-input v-model="form.cityId" placeholder="请输入市ID" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="市名称" prop="cityName" >-->
      <!--        <a-input v-model="form.cityName" placeholder="请输入市名称" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="区ID" prop="areaId" >-->
      <!--        <a-input v-model="form.areaId" placeholder="请输入区ID" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="区名称" prop="areaName" >-->
      <!--        <a-input v-model="form.areaName" placeholder="请输入区名称" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="医院地址" prop="address" >
        <div id="amap" style="height: 490px; width: 900px">
          <div style="height: 100%">
            <Map
              ref="map"
              @updateLocationMap="updateLocationMap"
              style="height: 100%"
            />
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="经纬度" prop="lon,lat" >
        <a-input
          v-model="form.lon"
          placeholder="经度"
          style="width: 48%; margin-right: 4%"
          disabled
        />
        <a-input
          v-model="form.lat"
          placeholder="纬度"
          style="width: 48%"
          disabled
        />
      </a-form-model-item>
      <a-form-model-item label="医院标志" prop="logo" >
        <file-upload
          :key="formType + '_logo_' + (form.id || 'new')"
          type="image"
          :defaultList="form.logoArr"
          :count="6"
          @input="getImg($event, 'logo')"/>
      </a-form-model-item>
      <a-form-model-item label="医院等级" prop="level" >
        <a-select v-model="form.level">
          <a-select-option v-for="item in dict.type['hospital_level']" :value="item.value" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="医院类型" prop="type" >
        <a-select v-model="form.type">
          <a-select-option v-for="item in dict.type['hospital_type']" :value="item.value" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="医院性质" prop="nature" >
        <a-select v-model="form.nature">
          <a-select-option v-for="item in dict.type['hospital_nature']" :value="item.value" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="固定荣誉" prop="fixedHonors">
        <a-checkbox :checked="form.isTop100 === 1" @change="handleFixedHonorChange('top100')">
          百强医院
        </a-checkbox>
      </a-form-model-item>
      <a-form-model-item label="自定义荣誉" prop="customHonors">
        <div v-for="(honor, index) in form.customHonors" :key="index" style="margin-bottom: 8px;">
          <a-input
            v-model="form.customHonors[index]"
            placeholder="请输入自定义荣誉名称"
            style="width: calc(100% - 80px); margin-right: 8px;"
          />
          <a-button type="danger" size="small" @click="removeCustomHonor(index)" v-if="form.customHonors.length > 1">
            删除
          </a-button>
        </div>
        <a-button type="dashed" size="small" @click="addCustomHonor" style="width: 100%;">
          <a-icon type="plus" /> 添加自定义荣誉
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="荣誉凭证" prop="certificateArr">
        <file-upload
          :key="formType + '_certificate_' + (form.id || 'new')"
          type="image"
          :defaultList="form.certificateArr"
          :count="9"
          @input="getImg($event, 'certificate')"/>
      </a-form-model-item>
      <a-form-model-item label="挂号二维码" prop="qrCode">
        <file-upload
          :key="formType + '_qrCode_' + (form.id || 'new')"
          type="image"
          :defaultList="form.qrCodeArr"
          :count="1"
          @input="getImg($event, 'qrCode')"/>
      </a-form-model-item>
      <a-form-model-item label="医院简介" prop="content" >
        <editor ref="contentEditor" v-model="form.content" :min-height="192" editor-id="content-editor"/>
      </a-form-model-item>
      <!--      <a-form-model-item label="荣誉证书" prop="certificate" >-->
      <!--        <file-upload type="image" :defaultList="form.certificateArr" :count="6"-->
      <!--                     @input="getImg($event, 'certificate')"/>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="华歧系数" prop="score" >-->
      <!--        <a-input-number :min="0" v-model="form.score" placeholder="请输入华歧系数" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHospital, addHospital, updateHospital } from '@/api/hospital/hospital'
import Editor from '@/components/Editor'
import FileUpload from '@/components/FileUpload'
import { guid } from '@/utils/ruoyi'
import { cityListTree } from '@/api/logistics'
import Map from './map.vue'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'CreateForm',
  props: {
  },
  dicts: ['hospital_level', 'hospital_type', 'hospital_nature'],
  components: {
    Editor,
    FileUpload,
    Map
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      addressSelect: '',
      addressList: [],
      // 表单参数
      form: {
        id: null,
        userId: null,
        hospitalAuthId: null,
        hospitalName: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        areaId: null,
        areaName: null,
        address: null,
        lon: null,
        lat: null,
        logo: null,
        logoArr: [],
        logoCount: 6,
        level: null,
        type: null,
        nature: null,
        honor: null,
        customHonors: [],
        isTop100: 0,
        top100Rank: null,
        content: null,
        certificate: null,
        certificateArr: [],
        certificateCount: 9,
        qrCode: null,
        qrCodeArr: [],
        qrCodeCount: 1,
        score: null,
        createTime: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        hospitalName: [
          { required: true, message: '医院名称不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '医院地址不能为空', trigger: 'blur' }
        ],
        lon: [
          { required: true, message: '请在地图上选择医院位置，经度不能为空', trigger: 'change' }
        ],
        lat: [
          { required: true, message: '请在地图上选择医院位置，纬度不能为空', trigger: 'change' }
        ],
        // logo: [
        //   { required: true, message: '医院标志不能为空', trigger: 'blur' }
        // ],
        level: [
          { required: true, message: '医院等级不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '医院类型不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  activated() {
    this.initHonor()
  },
  computed: {},
  watch: {
  },
  mounted () {
  },
  methods: {
    onDictReady(dict) {
      this.initHonor()
    },

    handleChange(val, selectedOptions) {
      this.form.provinceId = val[0]
      this.form.cityId = val[1]
      this.form.areaId = val[2]
      this.form.provinceName = selectedOptions[0].areaName
      this.form.cityName = selectedOptions[1].areaName
      this.form.areaName = selectedOptions[2].areaName
    },

    updateLocationMap(addr) {
      this.form.address = addr.orgAddr
      // 正确赋值经纬度到后台字段
      this.form.lon = addr.lon ? addr.lon.toString() : ''
      this.form.lat = addr.lat ? addr.lat.toString() : ''
      if (addr.province != null) {
        const province = this.addressList.find(
          (item) => item.areaName === addr.province
        )
        let city
        if (addr.city == null || addr.city === '') {
          city = province.children.find(
            (item) => item.areaName === addr.province
          )
        } else {
          city = province.children.find((item) => item.areaName === addr.city)
        }

        const area = city.children.find(
          (item) => item.areaName === addr.district
        )
        this.form.provinceId = province.areaId
        this.form.cityId = city.areaId
        this.form.areaId = area.areaId
        this.form.areaName = area.areaName
        this.form.provinceName = province.areaName
        this.form.cityName = city.areaName
        this.addressSelect = [province.areaId, city.areaId, area.areaId]
      }
    },

    initHonor() {
      cityListTree().then(res => {
        this.addressList = res.data
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },

    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].halfUrl
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.halfUrl }).join(',')
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 表单重置
    reset () {
      this.formType = 1
      // 重置省市区选择器
      this.addressSelect = ''
      // 强制重置所有文件上传数组，避免缓存问题
      const newForm = {
        id: null,
        userId: null,
        hospitalAuthId: null,
        hospitalName: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        areaId: null,
        areaName: null,
        address: null,
        lon: null,
        lat: null,
        logo: null,
        logoArr: [],
        logoCount: 6,
        level: null,
        type: null,
        nature: null,
        honor: null,
        customHonors: [''],
        isTop100: 0,
        top100Rank: null,
        content: null,
        certificate: null,
        certificateArr: [],
        certificateCount: 9,
        qrCode: null,
        qrCodeArr: [],
        qrCodeCount: 1,
        score: null,
        createTime: null,
        remark: null
      }
      this.form = newForm
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
        // 重置地图组件状态
        if (this.$refs.map) {
          this.$refs.map.clearMarker()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      // 初始化荣誉相关字段
      this.$set(this.form, 'customHonors', [''])
      this.$set(this.form, 'isTop100', 0)
    },
    initMarker(lon, lat, city, address) {
      // 等待下一个 tick 确保 map 组件已加载
      this.$nextTick(() => {
        if (this.$refs.map) {
          this.$refs.map.initMarker(lon, lat, city, address)
        }
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHospital({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        this.form.logoArr = []
        this.addressSelect = [this.form.provinceId, this.form.cityId, this.form.areaId]

        // 处理荣誉回显
        this.$set(this.form, 'isTop100', this.form.isTop100 || 0)
        this.$set(this.form, 'top100Rank', this.form.top100Rank || null)

        // 解析荣誉：从逗号分隔的字符串中解析
        this.$set(this.form, 'customHonors', [])
        if (this.form.honor) {
          const honorList = this.form.honor.split(',').map(item => item.trim())
          // 过滤掉"百强医院"，获取自定义荣誉
          const customHonorList = honorList.filter(item => item && item !== '百强医院')
          this.$set(this.form, 'customHonors', customHonorList.length > 0 ? customHonorList : [''])
        } else {
          this.$set(this.form, 'customHonors', [''])
        }

        // 处理荣誉证书回显
        this.form.certificateArr = []
        if (this.form.certificate) {
          const that = this
          this.form.certificate.split(',').forEach(item => {
            that.form.certificateArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: processImageUrl(item),
              path: item
            })
          })
        }

        this.initMarker(
          this.form.lon,
          this.form.lat,
          this.form.cityName,
          this.form.address
        )

       const that = this
        if (this.form.logo) {
          this.form.logo.split(',').forEach(item => {
            that.form.logoArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: processImageUrl(item),
              path: item
            })
          })
        }

        // 处理挂号二维码回显
        this.form.qrCodeArr = []
        if (this.form.qrCode) {
          const that = this
          this.form.qrCode.split(',').forEach(item => {
            that.form.qrCodeArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: processImageUrl(item),
              path: item
            })
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true

          // 处理荣誉数据：使用逗号分隔的字符串格式
          const honorList = []

          // 固定荣誉放在最前面
          if (this.form.isTop100 === 1) {
            honorList.push('百强医院')
          }

          // 自定义荣誉（过滤空值）
          if (this.form.customHonors && this.form.customHonors.length > 0) {
            const customHonors = this.form.customHonors.filter(h => h && h.trim() !== '')
            honorList.push(...customHonors)
          }

          // 转为逗号分隔的字符串
          this.form.honor = honorList.join(',')

          if (this.form.id !== undefined && this.form.id !== null) {
            updateHospital(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addHospital(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    // 添加自定义荣誉
    addCustomHonor () {
      this.form.customHonors.push('')
    },
    // 删除自定义荣誉
    removeCustomHonor (index) {
      this.form.customHonors.splice(index, 1)
      // 如果删除了最后一个，添加一个空项
      if (this.form.customHonors.length === 0) {
        this.form.customHonors.push('')
      }
    },
    // 处理固定荣誉变化
    handleFixedHonorChange (type) {
      if (type === 'top100') {
        this.form.isTop100 = this.form.isTop100 === 1 ? 0 : 1
        // 如果设置为百强医院，但没有设置排名，可以提示（可选）
        if (this.form.isTop100 === 1 && !this.form.top100Rank) {
          this.$message.info('已设置为百强医院，建议设置百强名次')
        }
      }
    }
  }
}
</script>
